<template>
  <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh" loosing-text="松开即可刷新..."> -->

  <div class="cooperation-detail-head-cp-container">
    <div class="detail-head">
      <span class="left-title">{{ body.pactName }}</span>
      <span
        :class="
          body && body.jsstate == '结算' ? 'text-icon-gray' : 'text-icon-gold'
        "
      >
        {{ body.jsstate }}
      </span>
      <p>
        签约日期：{{
          body.signDate && moment(body.signDate).format('YYYY-MM-DD')
        }}
      </p>
    </div>
    <template v-if="mainContract">
      <div class="detail-neck">
        <p>
          <span>所属公司：</span><span>{{ body.theirCompany }}</span>
        </p>
        <p>
          <span>所属项目：</span><span>{{ body.projname }}</span>
        </p>
        <p>
          <span>合同编号：</span><span>{{ body.contractcode }}</span>
        </p>
      </div>
      <div class="visa-details-container" v-if="mainContractInfo">
        <div>
          <span>{{ body.htamountzBz | money2 }}</span
          ><span>有效签约总额</span>
        </div>
        <div>
          <span>{{ body.adYdyjconfirmAmount | money2 }}</span
          ><span>一单一结确认累计金额</span>
        </div>
        <div>
          <span>{{ body.balanceSum | money2 }}</span
          ><span>结算金额</span>
        </div>
      </div>
    </template>
  </div>
  <!-- </van-pull-refresh> -->
</template>

<script>
import { PullRefresh } from 'vant';
import { getUrlParams } from 'common/js/mUtils';
import moment from 'moment';
export default {
  name: 'cooperation-detail-head-cp',

  data() {
    return {
      testData: [1, 2, 3],
      body: {},
      moment
    };
  },
  props: {
    mainContract: {
      type: Boolean,
      default: true
    },
    mainContractInfo: {
      type: Boolean,
      default: true
    }
  },
  mounted() {},
  created() {
    let { contractguid } = this.$route.query;
    this.init(contractguid);
  },

  components: {
    [PullRefresh.name]: PullRefresh
  },

  methods: {
    init(contractguid) {
      let { id } = getUrlParams();
      if (!contractguid) {
        contractguid = id;
      }
      this.$api.getContracStaisticsByid({ contractguid }).then(res => {
        let { status, body } = res;
        if (status) {
          this.body = body;
        }
      });
    }
  },
  watch: {
    $route: {
      handler: function() {
        let { contractguid } = this.$route.query;
        contractguid && this.init(contractguid);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.cooperation-detail-head-cp-container {
  background: transparent;
  position: relative;

  .visa-details-container {
    display: flex;
    height: 132px;
    justify-content: space-around;
    align-items: center;
    div {
      display: flex;
      flex-direction: column;
      text-align: center;
      position: relative;

      span:nth-child(1) {
        color: #000000;
        font-size: 32px;
        margin-bottom: 20px;
        font-weight: bold;
      }
      span:nth-child(2) {
        color: #666;
        font-size: 24px;
      }
    }
    div::after {
      position: absolute;
      content: '';
      border: 1px solid #f1f1f1;
      right: -40px;
      height: 52px;
      top: 20px;
      transform: scaleX(0.5);
    }
    div:last-child::after {
      border: none;
    }
    div:nth-child(3) {
      span:nth-child(1) {
        color: #36c490;
      }
    }
  }
  .detail-head {
    // height: 178px;
    border-bottom: 1px solid #efefef;
    padding: 32px;
    padding-top: 32px;
    p {
      margin-top: 25px;
      font-size: 26px;
      color: #666666;
    }
    .left-title {
      width: 80%;
      color: #000000;
      font-size: 32px;
      display: inline-block;
    }
    .right-icon {
      width: 120px;
      height: 40px;
      font-size: 22px;
      color: white;
      line-height: 40px;
      text-align: center;
      background: #cccccc;
      display: inline-block;
      position: absolute;
      right: 20px;
    }
    .text-icon-gold {
      width: 105px;
      height: 40px;
      display: inline-block;
      background: url('../../../common/images/visa-change/gold-icon.png')
        no-repeat center;
      background-size: 100% 100%;
      text-align: center;
      padding-left: 10px;
      color: white;
      line-height: 40px;
      font-size: 22px;
      position: absolute;
      right: 0px;
    }
    .text-icon-gray {
      width: 105px;
      height: 40px;
      display: inline-block;
      background: url('../../../common/images/visa-change/gray-icon.png')
        no-repeat center;
      background-size: 100% 100%;
      text-align: center;
      padding-left: 10px;
      color: white;
      line-height: 40px;
      font-size: 22px;
      position: absolute;
      right: 0px;
    }
  }
  .detail-neck {
    // height: 154px;
    border-bottom: 1px solid #efefef;
    padding: 20px;
    color: #666666;
    font-size: 26px;
    line-height: 1.5;
    p {
      margin-top: 8px;
      display: flex;
      span:nth-child(1) {
        color: #999;
        line-height: 1.5;
        display: inline-block;
        width: 140px;
      }
      span:nth-child(2) {
        color: #666;
        line-height: 1.5;
        flex: 1;
      }
    }
  }
  .detail-inside {
    height: 132px;
  }
}
</style>
<style lang="scss">
.cooperation-detail-head-cp-container {
}
</style>
